import log from "cslog";
import produce from "immer";
import { cloneDeep } from "lodash";
import { nanoid } from "nanoid";

export function createCreationFromTemplate(template, orgId) {
    const newData = cloneDeep(template.data);
    newData["slug"] = `${newData["slug"]}_${nanoid(5)}`;
    newData["organization"] = orgId;

    log.d(template.inputs, "Inputs");

    const used_schemas = [];
    if (template.inputs?.frontSide) {
        Object.keys(template.inputs.frontSide).forEach((key) => {
            const val = template.inputs.frontSide[key];
            if (val?.block_type === "qureal_preset") {
                used_schemas.push({
                    qdb_creation_schema_id: val?.data?.qureal_schema_id,
                });
            }
        });
    }

    newData["used_schemas"] = used_schemas;

    return newData;
}

export function replacePrefillInCreation(creation, prefill) {
    const newCreation = cloneDeep(creation);

    log.d(creation, "old creation");
    log.d(newCreation.data.pages[0].content, "old content");

    const new_prefill = {};
    Object.keys(prefill).forEach((key) => {
        if (prefill[key]) {
            new_prefill[key] = {
                ...newCreation?.data?.pages?.[0]?.content[key],
                data: {
                    ...newCreation?.data?.pages?.[0]?.content[key]?.data,
                    default: prefill[key]?.data,
                },
            };
        }
    });

    const out = produce(newCreation, (draft) => {
        draft.data.pages[0].content = {
            ...newCreation.data.pages[0].content,
            ...new_prefill,
        };
    });

    return out;
}
